export default __webpack_public_path__ + "static/media/PERFORMATIVE_ARTS.2f6e4cf8.svg";